import { Link } from 'react-router-dom';
import { externalLinkProps, links, routes } from '../../config/links';
import CTAButtons from '../CTAButtons/CTAButtons';
import OniLogo from '../OniLogo/OniLogo';
import { handleHomeClick } from '../../utils/scroll';
import styles from './Footer.module.css';

const footerLinks = [
  { href: routes.home, label: 'Home' },
  { href: routes.solutions, label: 'Stadiums & Arenas' },
  { href: routes.solutionsConcertVenues, label: 'Concert Venues' },
  { href: routes.features, label: 'Features' },
  { href: routes.howItWorks, label: 'How It Works' },
  { href: routes.technology, label: 'Technology' },
  { href: routes.about, label: 'About' },
  { href: routes.requestDemo, label: 'Request Demo' },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.brand}>
          <Link to={routes.home} className={styles.logoLink} aria-label="ONI home" onClick={handleHomeClick}>
            <OniLogo variant="full" />
          </Link>
          <p className={styles.tagline}>
            In-seat ordering and fulfillment for stadiums and arenas nationwide.
          </p>
        </div>

        <nav className={styles.links} aria-label="Footer">
          {footerLinks.map((link) => (
            <Link key={link.href} to={link.href}>
              {link.label}
            </Link>
          ))}
          <a href={links.customerUrl} {...externalLinkProps}>
            Fan Experience
          </a>
          <a href={links.adminUrl} {...externalLinkProps}>
            Login
          </a>
        </nav>

        <div className={styles.ctas}>
          <CTAButtons size="md" layout="column" showCustomerApp />
        </div>
      </div>

      <div className={`container ${styles.bottom}`}>
        <p>© {year} ONI. All rights reserved.</p>
        <p>
          <a href={links.siteUrl}>{links.siteUrl.replace(/^https?:\/\//, '')}</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
